export default "__VITE_ASSET__Bnyxt9UW__"